import React from "react";
import { ExternalLink } from "react-external-link";
import Mailto from "reactv16-mailto";
import { Helmet } from "react-helmet";

import "../App.css";
import "./InfoSection.css";

function infoSection() {
  return (
    <div className="infocontainer">
      <Helmet>
        <title>info — Octavio Garcia</title>
      </Helmet>

      <div className="info-parent">
        <div className="section-1">
          <p className="bio">
            Octavio is a Texas native currently based out of Austin.<br></br>
            B.1992 Del Rio
          </p>

          <p>
            email -
            <Mailto
              className="email"
              email="hello@octaviogarcia.co"
              obfuscate={true}
            >
              hello@octaviogarcia.co
            </Mailto>
          </p>
          <p>
            social -
            <ExternalLink href="https://www.instagram.com/octaviusgarcia/">
              <span> instagram</span>
            </ExternalLink>
            ,
            <ExternalLink href="https://www.flickr.com/photos/155948075@N08/">
              <span> flickr </span>
            </ExternalLink>
            <p className="press"> —* </p>
            {/* 
              <p className="interview"> interview </p>

              <ExternalLink href="https://www.lomography.com/magazine/342545-it-s-never-lonely-in-the-suburbs-photo-story-by-octavio-garcia">
                <span> 
                  Lomography - It's Never Lonely in the Suburbs 
                </span>
              </ExternalLink>
              */}
          </p>
        </div>
        <div className="imgplaceholder"></div>
      </div>
    </div>
  );
}

export default infoSection;
